import React, { useState } from "react";

// PAGE: Shows all orders in a table with filters (adapted from devices)
const OrdersView = ({ orders, locationMap, categoryMetrics, dateRange }) => {
  // STATE: Which filter is the user using?
  const [filter, setFilter] = useState("all");

  // FUNCTION: Filter orders based on selected filter + date range
  const filteredOrders = orders.filter((o) => {
    const duration = o.billingDuration || 0;
    const borrowTime = new Date(o.pBorrowtime);
    const category =
      Object.entries(categoryMetrics).find(([cat, ids]) =>
        ids.includes(o.pCabinetid)
      )?.[0] || "OTHER";

    // Date filter: Must fall within dateRange
    if (
      dateRange.start &&
      dateRange.end &&
      (borrowTime < dateRange.start || borrowTime > dateRange.end)
    ) {
      return false;
    }

    // Category/Duration filters
    if (filter === "short") return duration < 30; // Short rentals
    if (filter === "long") return duration >= 60; // Long rentals
    if (filter === "airport") return category === "AIRPORT";
    if (filter === "ent") return category === "ENT. FAC";
    if (filter === "malls") return category === "MALLS / HOSPITAL";
    return true; // Show all
  });

  // Render the page
  return (
    <div className="devices-view">
      <div className="devices-header">
        <h2 className="section-header">
          <i className="fas fa-plug"></i> Order Management
        </h2>
        {/* Date Range Display */}
        {dateRange.start && dateRange.end && (
          <div
            style={{ marginLeft: "auto", fontSize: "0.9rem", color: "#64748b" }}
          >
            Filtered: {dateRange.start.toLocaleDateString()} to{" "}
            {dateRange.end.toLocaleDateString()}
          </div>
        )}
        {/* Filter buttons */}
        <div className="device-filters">
          <button
            className={`filter-btn ${filter === "all" ? "active" : ""}`}
            onClick={() => setFilter("all")}
          >
            All ({orders.length})
          </button>
          <button
            className={`filter-btn ${filter === "short" ? "active" : ""}`}
            onClick={() => setFilter("short")}
          >
            Short Rentals (
            {orders.filter((o) => (o.billingDuration || 0) < 30).length})
          </button>
          <button
            className={`filter-btn ${filter === "long" ? "active" : ""}`}
            onClick={() => setFilter("long")}
          >
            Long Rentals (
            {orders.filter((o) => (o.billingDuration || 0) >= 60).length})
          </button>
          <button
            className={`filter-btn ${filter === "airport" ? "active" : ""}`}
            onClick={() => setFilter("airport")}
          >
            Airports ({categoryMetrics.AIRPORT?.length || 0})
          </button>
          <button
            className={`filter-btn ${filter === "ent" ? "active" : ""}`}
            onClick={() => setFilter("ent")}
          >
            Entertainment ({categoryMetrics["ENT. FAC"]?.length || 0})
          </button>
          <button
            className={`filter-btn ${filter === "malls" ? "active" : ""}`}
            onClick={() => setFilter("malls")}
          >
            Malls/Hospitals ({categoryMetrics["MALLS / HOSPITAL"]?.length || 0})
          </button>
        </div>
      </div>

      {/* Table showing all orders */}
      <div className="devices-table-container">
        <table className="devices-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Cabinet ID</th>
              <th>Location</th>
              <th>User</th>
              <th>Duration (min)</th>
              <th>Revenue (Ksh)</th>
              <th>Borrow Time</th>
              <th>Return Time</th>
            </tr>
          </thead>
          <tbody>
            {/* Show each order in the table */}
            {filteredOrders.map((order, idx) => {
              // Calculate each row's values
              const duration = order.billingDuration || 0;
              const location =
                order.pShopName ||
                locationMap[order.pCabinetid] ||
                "Unassigned";
              const borrowTime = new Date(order.pBorrowtime).toLocaleString();
              const returnTime = order.pGhtime
                ? new Date(order.pGhtime).toLocaleString()
                : "Pending";
              const revenue = (order.pJiesuan || 0).toFixed(2);

              // Render one row
              return (
                <tr key={idx}>
                  <td className="cabinet-id">
                    {order.pOrderid || order.pAliorderid}
                  </td>
                  <td className="cabinet-id">{order.pCabinetid}</td>
                  <td>{location}</td>
                  <td>{order.fUsername || "Unknown"}</td>
                  <td>{duration}</td>
                  <td>{revenue}</td>
                  <td className="last-updated">{borrowTime}</td>
                  <td className="last-updated">{returnTime}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrdersView;
